<script lang="ts">
    import { reviewsIconCollectionManagerContextToken } from "@apps/reviews/context_tokens";
    import { getTypedContext } from "@lib/svelte-typed-context";
    import { createEventDispatcher } from "svelte";

    import Button from "@components/Buttons/Button.svelte";
    import EmptyState from "@components/EmptyState/EmptyState.svelte";
    import Icon from "@components/Icon.svelte";

    import ReviewsEmptyListBackgroundIcon from "./icons/ReviewsEmptyListBackgroundIcon.svelte";

    export let title: string;

    export let actionText: string | undefined = undefined;

    const dispatch = createEventDispatcher();

    const handleAction = () => {
        dispatch("action");
    };

    const iconCollection$ = getTypedContext(
        reviewsIconCollectionManagerContextToken
    ).getIconCollection();
</script>

<EmptyState>
    <svelte:fragment slot="icon">
        <div class="gw-rv-empty-list__icon">
            <Icon width={100} height={80} viewBox="0 0 100 84">
                <ReviewsEmptyListBackgroundIcon />
            </Icon>
            <div class="gw-rv-empty-list__star">
                <Icon width={40} height={40} title="empty list icon">
                    <svelte:component this={$iconCollection$?.filled} />
                </Icon>
            </div>
        </div>
    </svelte:fragment>

    <p slot="title" class="gw-rv-empty-list__title">{title}</p>

    <svelte:fragment slot="footer">
        {#if actionText}
            <Button
                class="gw-rv-empty-list__action-button"
                variant="link"
                on:click={handleAction}
            >
                {actionText}
            </Button>
        {/if}
    </svelte:fragment>
</EmptyState>

<style lang="postcss">
    .gw-rv-empty-list {
        &__title {
            color: #979faf;
            font-size: 1em;
            font-weight: 400;
            line-height: 1.2em;
            margin: 0;
        }

        &__icon {
            position: relative;
        }

        &__star {
            position: absolute;
            top: 52%;
            left: 48%;
            transform: translate(-50%, -50%);
            color: #aab2c5;
        }
    }

    :global(.gw-btn.gw-button.gw-rv-empty-list__action-button) {
        color: #3772ff;
        font-size: 0.9em;
    }
</style>
